import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { updateCredits, updateUser } from '../slices/authSlice';
import authFetch from '../utils/authFetch';

const UNLOCK_ITEMS = [
    'Détail du score sur 5 critères',
    'Toutes les recommandations',
    'Mots-clés ATS présents et manquants',
    'CV restructuré à copier ou télécharger',
];

const Success = () => {
    const dispatch = useDispatch();
    const userId = useSelector((state) => state.auth.user?.id);
    const token = useSelector((state) => state.auth.token);
    const [ready, setReady] = useState(false);

    useEffect(() => {
        let cancelled = false;
        const refreshAccess = async () => {
            if (!userId || !token) {
                setReady(true);
                return;
            }
            try {
                const response = await authFetch(`https://cvanalyzerback.osc-fr1.scalingo.io/api/users/${userId}/credits`);
                if (response.ok) {
                    const data = await response.json();
                    if (!cancelled) {
                        if (data.credits !== undefined) {
                            dispatch(updateCredits(data.credits));
                        }
                        if (typeof data.hasPaid === 'boolean') {
                            dispatch(updateUser({ hasPaid: data.hasPaid }));
                        }
                    }
                }
            } catch {
                // Le rapport se débloque aussi depuis /upload
            } finally {
                if (!cancelled) setReady(true);
            }
        };
        refreshAccess();
        return () => {
            cancelled = true;
        };
    }, [userId, token, dispatch]);

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-b from-blue-50 to-indigo-50 p-6">
            <Helmet>
                <title>Paiement réussi | CV Analyse</title>
                <meta name="robots" content="noindex, nofollow" />
                <link rel="canonical" href="https://www.cv-analyse.fr/success" />
            </Helmet>
            <div className="bg-white p-8 rounded-2xl shadow-xl w-full max-w-lg">
                <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-green-100 flex items-center justify-center">
                    <svg className="w-9 h-9 text-green-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                </div>
                <h1 className="text-3xl font-extrabold text-gray-800 mb-2 text-center">Paiement réussi</h1>
                <p className="text-gray-600 mb-6 text-center">
                    Paiement confirmé. Importez à nouveau votre CV : l&apos;IA génère le rapport complet, l&apos;ATS et le CV restructuré.
                </p>
                <ul className="space-y-2 mb-8 text-sm text-gray-700">
                    {UNLOCK_ITEMS.map((item) => (
                        <li key={item} className="flex items-start gap-2">
                            <span className="text-green-600 font-bold mt-0.5">✓</span>
                            <span>{item}</span>
                        </li>
                    ))}
                </ul>
                {token ? (
                    <Link
                        to="/upload"
                        className="block w-full text-center bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-3 rounded-xl shadow-md"
                    >
                        {ready ? 'Importer mon CV pour l’analyse IA' : 'Préparation du compte…'}
                    </Link>
                ) : (
                    <Link
                        to="/login"
                        className="block w-full text-center bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-3 rounded-xl shadow-md"
                    >
                        Se connecter pour voir le rapport
                    </Link>
                )}
            </div>
        </div>
    );
};

export default Success;
